import { Form, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import useSWR from 'swr';

import { useCallback } from 'react';
import { queryParams } from '@shared/commonFunctions';
import { Modal } from '@shared/components/modals/Modal';
import { SERVICES } from '@shared/constants/apiConfig';
import { updateCounter } from '@store/reducers/reminderSlice';

import { useUserAccount } from '@shared/hooks/useUserAccount';
import { setLastCommentsRefresh } from '@store/reducers/contactManagerSlice';
import { requestCreateReminder } from '../requests';
import { IDealSummary } from '../../Tabs/components/Deals/interfaces';
import { AddReminderForm } from './AddReminderForm';

interface IAddReminderProps {
  dealSummary: IDealSummary[] | [];
  openReminder: number;
  onClose: () => void;
}
export interface IReminderModel {
  userId: string | null;
  contactId: string;
  dealId: string;
  reminderDate: string;
  description: string;
  isEmailReminder: boolean;
}

export interface IMultipleReminders {
  reminderIds: string[];
}

export const AddReminderModal = ({ dealSummary, openReminder, onClose }: IAddReminderProps) => {
  const { userId } = useUserAccount();
  const dispatch = useDispatch();
  const params = queryParams();

  const { data: users } = useSWR(`/${SERVICES.USER}/users`);

  const handleSubmit = useCallback(
    async (data: IReminderModel) => {
      !data.userId && (data.userId = userId || null);
      data.contactId = params?.id;
      data.dealId = params?.dealId === '' ? null : params?.dealId;
      !data.reminderDate && (data.reminderDate = new Date().toISOString());
      await requestCreateReminder(data).then(onClose);
      dispatch(updateCounter());
      dispatch(setLastCommentsRefresh(new Date().toISOString()));
    },
    [userId, updateCounter, params?.dealId, params?.id]
  );

  const reminderInitialValues: IReminderModel = {
    dealId: params?.dealId || '',
    reminderDate: '',
    isEmailReminder: false,
    description: '',
    userId: '',
    contactId: '',
  };

  return (
    <Modal
      hideBackdrop
      marginTop="0"
      title="Add Reminder"
      open={!!openReminder}
      resetPosition={openReminder}
      dialogWidth="700px"
      onClose={onClose}
    >
      <Formik
        enableReinitialize
        initialValues={reminderInitialValues as IReminderModel}
        onSubmit={handleSubmit}
      >
        {(props) => (
          <Form>
            {
              <AddReminderForm
                deals={dealSummary}
                users={users}
                handleClose={onClose}
                {...props}
              />
            }
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
